import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { IconNames } from 'atoms/Icon/Icon.h'
import { COLOR } from 'vars/color'
import { FIXED_INDENTS } from 'vars/index'
import { Button } from '../Button'
import {
  ButtonBordersWidth,
  ButtonColors,
  ButtonCorners,
  ButtonFluid,
  ButtonFonts,
  ButtonIconSizes,
  IconPositions,
} from '../Button.h'

export interface IPageBackButtonProps extends IButtonProps {}

export const PageBackButton = ({
  icon = IconNames.arrowLeft,
  iconPosition = IconPositions.Center,
  iconSize = ButtonIconSizes.xSm,
  corners: _unused1 = ButtonCorners.CORNERS_10,
  colorDefault: _unused2 = ButtonColors.COLOR_PRIMARY,
  colorDisabled: _unused3 = ButtonColors.COLOR_DISABLED,
  backgroundColorDefault: _unused4 = COLOR.TRANSPARENT,
  backgroundColorDisabled: _unused5 = COLOR.TRANSPARENT,
  borderWidth: _unused6 = ButtonBordersWidth.BORDER_0,
  font: _unused7 = ButtonFonts.Button1,
  fluid: _unused8 = ButtonFluid.None,
  paddings = [FIXED_INDENTS.INDENT_30, FIXED_INDENTS.INDENT_30],
  ...rest
}: IPageBackButtonProps): JSX.Element => {
  return (
    <Button
      icon={icon}
      iconPosition={iconPosition}
      iconSize={iconSize}
      corners={ButtonCorners.CORNERS_0}
      colorDefault={ButtonColors.COLOR_PRIMARY}
      colorDisabled={ButtonColors.COLOR_DISABLED}
      backgroundColorDefault={COLOR.TRANSPARENT}
      backgroundColorDisabled={COLOR.TRANSPARENT}
      borderWidth={ButtonBordersWidth.BORDER_0}
      font={ButtonFonts.Button1}
      fluid={ButtonFluid.None}
      paddings={paddings}
      {...rest}
    />
  )
}
